import { RouteObject } from 'react-router-dom'
import { RoutesEnum } from '../../enums/RoutesEnum'
import { AccompanyingReport } from '../../../pages/Project/subpages/AccompanyingReport/AccompanyingReport'
import React from 'react'
import { DocumentationSection } from '../../../pages/Project/subpages/DocumentationSection'
import { FolderKeyEnum } from '../../enums/FolderKeyEnum'
import { ProjectFormCategoryEnum, ProjectFormEnum } from 'shared'
import { DemolitionB1Area } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/demolitionPermit/B1Area/DemolitionB1Area'
import { DemolitionB2Connections } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/demolitionPermit/B2Connections/DemolitionB2Connections'
import { DemolitionB3Terrain } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/demolitionPermit/B3Terrain/DemolitionB3Terrain'
import { DemolitionB4Organization } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/demolitionPermit/B4Organization/DemolitionB4Organization'
import { TechnicalReportForm } from '../../../pages/Project/subpages/TechnicalReportForm/TechnicalReportForm'

export const demolitionPermitRoutes: RouteObject[] = [
  // Acc report
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DEMOLITION_ACCOMPANYING_REPORT}`,
    element: (
      <AccompanyingReport projectForm={ProjectFormEnum.DEMOLITION_ACCOMPANYING_REPORT_FORM_A1} />
    ),
  },

  // TechReport
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DEMOLITION_TECHNICAL_REPORT_FORM}`,
    element: <TechnicalReportForm projectFormCategory={ProjectFormCategoryEnum.DEMOLITION_PERMIT} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B1}`,
    element: <DemolitionB1Area />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B2}`,
    element: <DemolitionB2Connections />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B3}`,
    element: <DemolitionB3Terrain />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.DEMOLITION_TECHNICAL_FORM_B4}`,
    element: <DemolitionB4Organization />,
  },

  // Files
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DEMOLITION_DOCUMENTATION_SECTION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.DEMOLITION_FORM_ATTACHMENTS} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DEMOLITION_OBJECT_DOCUMENTATION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.DEMOLITION_OBJECT_DOCUMENTATION} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DEMOLITION_SITUATION_DOCUMENTATION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.DEMOLITION_SITUATION_DOCUMENTATION} />,
  },
]
